/*
 * @Author: Chao Yang
 * @Date: 2020-09-22 08:49:23
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-09-06 13:07:37
 */
import { Injectable } from '@angular/core';
import { BaseProxy } from '../base.proxy';
import { Observable } from 'rxjs';
import * as DataRoomEditorModel from 'src/app/domain/model/offering/editor';

@Injectable()
export class DataRoomEditorProxy extends BaseProxy {
  getMarketingFundName(marketingFundId: number): Observable<string> {
    return this._http.get<string>(`/ip/api/fund/${marketingFundId}/name`);
  }

  getMarketingFundDetailPageDraft(
    marketingFundId: number
  ): Observable<DataRoomEditorModel.IDraft> {
    return this._http.get<DataRoomEditorModel.IDraft>(
      `/ip/api/fund/${marketingFundId}/marketing/editor/draft`
    );
  }

  getMarketingFundDetailPageFields(
    marketingFundId: number
  ): Observable<DataRoomEditorModel.IField[]> {
    return this._http.get<DataRoomEditorModel.IField[]>(
      `/ip/api/fund/${marketingFundId}/marketing/editor/field`
    );
  }

  getMarketingFundDetailPageUserPermission(
    marketingFundId: number
  ): Observable<boolean> {
    return this._http.get<boolean>(
      `/ip/api/fund/${marketingFundId}/marketing/editor/permission`
    );
  }

  publishMarketingFundDetailPageDraft(
    marketingFundId: number,
    draft: DataRoomEditorModel.IDraft
  ): Observable<number> {
    return this._http.post<number>(
      `/ip/api/fund/${marketingFundId}/marketing/editor/draft/publish`,
      draft
    );
  }

  saveMarketingFundDetailPageDraft(
    marketingFundId: number,
    draft: DataRoomEditorModel.IDraft
  ): Observable<number> {
    return this._http.post<number>(
      `/ip/api/fund/${marketingFundId}/marketing/editor/draft`,
      draft
    );
  }

  uploadBannerImageLink(): string {
    return '/ip/api/fund/marketing/editor/banner/image';
  }

  uploadPhotoLink(): string {
    return '/ip/api/fund/marketing/editor/photo';
  }

  uploadVideoLink(): string {
    return '/ip/api/fund/marketing/editor/video';
  }

  getOfferingDetailPermission(marketingFundId: number): Observable<boolean> {
    return this._http.get<boolean>(
      `/ip/api/fund/${marketingFundId}/detail/permission`
    );
  }

  storeDraftData(
    marketingFundId: string,
    draft: DataRoomEditorModel.IDraft
  ): Observable<unknown> {
    return this._http.post<unknown>(
      `/ip/api/fund/${marketingFundId}/marketing/editor/draft/store`,
      draft
    );
  }

  getDraftData(
    marketingFundId: string,
    draftId: number
  ): Observable<DataRoomEditorModel.IDraft> {
    return this._http.get<DataRoomEditorModel.IDraft>(
      `/ip/api/fund/${marketingFundId}/marketing/draft/${draftId}`
    );
  }
}
